import { useRef, useEffect } from 'react';
import { throttle } from 'lodash-es';

export const useScrollRef = <T extends HTMLElement>(setVisible: (visible: boolean) => void) => {
  const scrollRef = useRef<T>(null);

  useEffect(() => {
    const handleScroll = throttle(() => {
      const { top } = scrollRef.current?.getBoundingClientRect() || {};
      if (typeof top !== 'undefined') {
        setVisible(top < 60);
      }
    }, 100);
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      return window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return scrollRef;
};
